import React from 'react';
import './App.css';
import PathfindingVisualization from './PathfindingVisualization/PathfindingVisualization'

function App() {
  return (
    <div className="App">
      <PathfindingVisualization></PathfindingVisualization>
    </div>
  );
}

export default App;
